// A step's timer from its text: "Simmer for 15 minutes", "Koka 10–12 min",
// "Bake 1 hour", "1 time og 30 minutter", in every language lib/recipeWords.ts
// knows. Read by the
// recipe editor and, through `make shared-lib`, by the `recipe` function for
// imported steps and a pasted recipe's "UNDER 30 MIN" — one definition.
//
// A range takes its upper end: a timer that rings early is worse than a
// minute of checking. Matched on a bounded slice with patterns that don't
// backtrack.

import { HOUR_WORDS, MINUTE_WORDS, anyOf } from './recipeWords'

/** A day: longer is a typo, not a timer. */
export const MAX_STEP_MINUTES = 1440
const MAX_SCAN = 1000

const MINUTES = new RegExp(`(\\d{1,3})(?:\\s?[-–]\\s?(\\d{1,3}))?\\s?(?:${anyOf(MINUTE_WORDS)})(?!\\p{L})`, 'iu')
const HOURS = new RegExp(`(\\d{1,2})(?:\\s?[-–]\\s?(\\d{1,2}))?\\s?(?:${anyOf(HOUR_WORDS)})(?!\\p{L})`, 'iu')

/** Between "1 hour" and "30 minutes" in one time: a space, "and", a comma. */
const MAX_JOIN = 8

export function stepMinutes(text: string): number | null {
  const s = text.slice(0, MAX_SCAN)
  const min = s.match(MINUTES)
  const hr = s.match(HOURS)
  let n: number | null = null
  if (hr && min && hr.index! < min.index! && min.index! - (hr.index! + hr[0].length) <= MAX_JOIN) {
    n = Number(hr[2] ?? hr[1]) * 60 + Number(min[2] ?? min[1])
  } else if (min) n = Number(min[2] ?? min[1])
  else if (hr) n = Number(hr[2] ?? hr[1]) * 60
  return n !== null && n > 0 && n <= MAX_STEP_MINUTES ? n : null
}
